var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.93097 0H4.06904C1.51976 0 0 1.51976 0 4.06904V9.93097C0 12.4802 1.51976 14 4.06904 14H9.93097C12.4802 14 14 12.4802 14 9.93097V4.06904C14 1.51976 12.4802 0 9.93097 0Z",
    fill: "#B1B1B1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 4.59862V5.39793H11V4.59862L7.03983 3L3 4.59862Z",
    fill: "#052f35 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64438 5.80008H3.75549V9.40001H4.64438V5.80008Z",
    fill: "#052f35 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5112 5.80008H5.62231V9.40001H6.5112V5.80008Z",
    fill: "#052f35 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37766 5.80008H7.48877V9.40001H8.37766V5.80008Z",
    fill: "#052f35 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2442 5.80008H9.35535V9.40001H10.2442V5.80008Z",
    fill: "#052f35 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5998 9.75555H3.3999V10.1999H10.5998V9.75555Z",
    fill: "#052f35 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10.4H3V11H11V10.4Z",
    fill: "#052f35 "
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.430a2f8c.svg";
export { ForwardRef as ReactComponent };